import React from 'react'
import { Broadcast } from 'react-broadcast'
import { Query } from 'react-apollo'
import graphqlQuery from 'graphs/queries/Server.graphql'

const ServerProvider = ({ children, ...rest }) => (
  <Query query={graphqlQuery} {...rest}>
    {({ loading, data: { server } }) => (
      <Broadcast channel="server" value={{ loading, server }}>
        {children}
      </Broadcast>
    )}
  </Query>
)

export default ServerProvider



// WEBPACK FOOTER //
// ./src/components/Server/Provider.js